import React, { useState } from "react";

import { useParams, useNavigate, Link } from "react-router-dom";
import GlobalLogo from "../../component/SvgIcons/GlobalLogo";
import IconKey from "../../component/SvgIcons/IconKey";
import Logo from "../../component/SvgIcons/Logo";
import api from "../../services/axios";
import { useSwal } from "../../services/SweetAlert";
import "./style.css";

export default function ForgotPassword() {
  const [showPassword, setShowPassword] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const {alert}= useSwal();
  const navigate = useNavigate();

  // Get token from query params like /reset-password?token=abcdef...

const { token } = useParams();
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!newPassword || !confirmPassword) {
      return alert("warning", "Please fill all fields.");
    }

    if (newPassword !== confirmPassword) {
      return alert("warning", "Passwords do not match.");
    }

    if (!token) {
      return alert("error", "Reset token is missing or invalid.");
    }

    try {
      const response = await api.post("/reset-password", {
        token,
        newPassword,
      });

      alert("success", response.data.message || "Password reset successful!");
      navigate("/"); // redirect to login
    } catch (error) {
      alert("error", error.response?.data?.message || "Failed to reset password.");
    }
  };

  return (
    <div className="login-main">
      <form className="loginform" onSubmit={handleSubmit}>
        <div className="advisor-logo">
          <GlobalLogo />
          <img src="../images/Gulf-logo.svg" alt="Gulf-logo" />
        </div>

        <div className="create-form d-flex flex-column">
          <div className="login-logo text-center">
            <Logo />
          </div>

          <h1 className="text-center">Your Password Reset Link (Valid for 1 Hour)</h1>

          <div className="form-group">
            <label>New Password</label>
            <input
              type={showPassword ? "text" : "password"}
              name="newPassword"
              className="form-control"
              placeholder="Enter New Password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />
            <Link
              className="hereshowpassword tranparenteffect"
              onClick={() => setShowPassword(!showPassword)}
            >
              <IconKey />
            </Link>
          </div>

          <div className="form-group">
            <label>Confirm Password</label>
            <input
              type={showPassword ? "text" : "password"}
              name="confirmPassword"
              className="form-control"
              placeholder="Confirm New Password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
            <Link
              className="hereshowpassword tranparenteffect"
              onClick={() => setShowPassword(!showPassword)}
            >
              <IconKey />
            </Link>
          </div>

          <button type="submit" className="btn btngradiant">
            Submit
          </button>

          <Link to="/" className="forgotpassword text-center">
            Back to Login
          </Link>

          <span className="text-center">©GlobalSoftware</span>
        </div>
      </form>
    </div>
  );
}
